var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"title":_vm.$t('buttons.info'),"aria-label":_vm.$t('buttons.info')},on:{"click":_vm.show}},[_c('i',{staticClass:"material-icons"},[_vm._v("info")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.info')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7e6be3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Info.vue
// module id = 357
// module chunks = 0